import type React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import type { ComingSoonModules } from "models/product/ProductDetails";

import { buildUrlWithPathParams } from "_helpers/utils/urlBuilder";
import { PLACEHOLDER_PAGE_ROUTES } from "constants/routes";

import { ParagraphLarge } from "styles/elements/Texts";
import { CssFlex } from "styles/helpers/layout";
import {
  StyledFooter,
  StyledInterestedButton,
  StyledModuleCard,
  StyledSubtitle,
} from "./ComingSoonModuleCard.styled";

interface ModuleCardProps {
  productId: number;
  comingSoonModule: ComingSoonModules;
}

export const ComingSoonModuleCard: React.FC<ModuleCardProps> = ({
  productId,
  comingSoonModule,
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation("homepage");

  const onCardClick = () => {
    navigate(
      buildUrlWithPathParams(PLACEHOLDER_PAGE_ROUTES.COMING_SOON_MODULE, {
        productId,
        moduleType: comingSoonModule.type,
      }),
    );
  };

  const handleSubscribeNewModules = () => {
    window.open(comingSoonModule.subscriptionUrl, "_blank", "noopener,noreferrer");
  };

  return (
    <StyledModuleCard
      comingSoon
      onClick={onCardClick}
      key={comingSoonModule.type}
      dataCy={`coming-soon-${comingSoonModule.type}-module-card`}
      title={comingSoonModule.title}
    >
      <CssFlex flexDirection="column" flexGrow={1} overflowY="auto" rowGap={0.5}>
        <StyledSubtitle data-cy="coming-soon-subtitle">
          {t("studentDashboard.comingSoonModules.subtitle", {
            moduleName: comingSoonModule.title,
          })}
        </StyledSubtitle>
        <ParagraphLarge flexGrow="1">{comingSoonModule.description}</ParagraphLarge>
        <StyledFooter>
          <StyledInterestedButton variant="primary-outline" onClick={handleSubscribeNewModules}>
            {t("studentDashboard.comingSoonModules.interestedButton")}
          </StyledInterestedButton>
        </StyledFooter>
      </CssFlex>
    </StyledModuleCard>
  );
};
